export default class Webcam {
  private videoElement: HTMLVideoElement
  private stream: MediaStream | null = null

  constructor(videoElement: HTMLVideoElement) {
    this.videoElement = videoElement
  }

  async start(deviceId?: string): Promise<void> {
    try {
      const constraints: MediaStreamConstraints = deviceId
        ? { video: { deviceId: { exact: deviceId } } }
        : { video: true }
      this.stream = await navigator.mediaDevices.getUserMedia(constraints)
      this.videoElement.srcObject = this.stream
      await this.videoElement.play()
    }
    catch (error) {
      console.error('Error starting webcam:', error)
      throw new Error('Could not access the webcam.')
    }
  }

  captureSnapshot(canvasElement: HTMLCanvasElement): string {
    const context = canvasElement.getContext('2d')
    if (!context) {
      throw new Error('Could not get canvas context')
    }
    canvasElement.width = this.videoElement.videoWidth
    canvasElement.height = this.videoElement.videoHeight
    context.drawImage(this.videoElement, 0, 0, canvasElement.width, canvasElement.height)
    return canvasElement.toDataURL('image/png')
  }

  stop(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop())
      this.videoElement.srcObject = null
    }
  }
}

export async function getAvailableWebcams(): Promise<MediaDeviceInfo[]> {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    return devices.filter(device => device.kind === 'videoinput')
  }
  catch (error) {
    console.error('Error listing webcams:', error)
    throw new Error('Could not access the list of webcams.')
  }
}
